import React from "react";
import DashboardWidgetContainer from "../../../containers/DashboardWidget/DashboardWidgetContainer";
import { widgetKeys } from "../../../constants";
import makeStyles from "@mui/styles/makeStyles";
import { Box, Link } from "@mui/material";
import { useTranslation } from "react-i18next";
import RatingQuestionsList from "./RatingQuestionsList";
import { useKingsleyKpis, useKingsLink } from "../../../hooks/kingsley";
import PropTypes from "prop-types";
import Skeleton from "../../Skeleton/Skeleton";

const useStyles = makeStyles(theme => ({
  linkWrapper: {
    ...theme.typography.button,
    "& a": {
      cursor: "pointer"
    }
  }
}));

const Loader = () => (
  <Box display="flex" flex={1} justifyContent="center">
    <Skeleton loading width={380} height={160} mx={1} />
    <Skeleton loading width={380} height={160} mx={1} />
  </Box>
);

const KingsleyPortal = ({ dashboard, bgColor }) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const { ratingQuestions, isLoading } = useKingsleyKpis();
  const { openKingsLink } = useKingsLink();
  const handleOpenKingsleyPortal = () => {
    openKingsLink && openKingsLink();
  };

  return (
    <DashboardWidgetContainer
      bgColor={bgColor}
      dashboard={dashboard}
      widgetKey={widgetKeys.kingsley}
      title={t("kingsleyWidget.title")}
      collapsed={false}
    >
      {isLoading ? (
        <Loader />
      ) : ratingQuestions && Array.isArray(ratingQuestions) ? (
        <RatingQuestionsList
          ratingQuestions={ratingQuestions}
          openKingsleyPortalClick={handleOpenKingsleyPortal}
        />
      ) : ratingQuestions && ratingQuestions["message"] ? (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          className={classes.linkWrapper}
        >
          <Link variant="button" onClick={handleOpenKingsleyPortal}>
            {t("kingsleyWidget.message")}
          </Link>
        </Box>
      ) : null}
    </DashboardWidgetContainer>
  );
};

export default KingsleyPortal;

KingsleyPortal.propTypes = {
  dashboard: PropTypes.string,
  bgColor: PropTypes.bool
};
